<template>
    <div :id="popupId" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h2><img src="/img/Alerts/plusbig_icon.png" /> Company Tutorial Video</h2>
                    <button ref="popupCloseButton" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                <div class="modal-body">
                    <form v-on:submit.prevent="addBrandTutorialVideo" data-vv-scope="add-brand-tutorial-video">
                      <div class="row">
                          <div class="col-sm-12">
                            <h3>Title</h3>
                            <input type="text" placeholder="Add Video Title" name="title" v-model="brandTutorialVideoDetails.title" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('add-brand-tutorial-video.title') }" />
                          </div>
                          <div class="col-sm-12">
                            <h3>Order</h3>
                            <input type="text" placeholder="Add Video Order" name="order" v-model="brandTutorialVideoDetails.order" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('add-brand-tutorial-video.order') }" />
                          </div>
                          <div class="col-sm-12">
                            <h3>Description</h3>
                            <textarea type="text" placeholder="Add Video Title" name="description" v-model="brandTutorialVideoDetails.description" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('add-brand-tutorial-video.description') }" ></textarea>
                          </div>
                          <div class="col-sm-12">
                            <h3>Video Link</h3>
                            <input type="text" placeholder="Add Video URL" name="videoUrl" v-model="brandTutorialVideoDetails.video_url" v-validate="{required: true, url: { require_protocol: true }}" :class="{'input': true, 'is-danger': errors.has('add-brand-tutorial-video.videoUrl') }" @change="getVideoId()"/>
                          </div>
                          <div class="col-sm-12">
                            <h3>Video ID</h3>
                            <input type="text" disabled placeholder="Add Video ID" name="videoId" v-model="brandTutorialVideoDetails.video_id" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('add-brand-tutorial-video.videoId') }" />
                          </div>
                        </div>
                       <input type="submit" class="btn-lg-green" :value="editBrandTutorialVideoFlag ? 'UPDATE TUTORIAL VIDEO' : 'ADD TUTORIAL VIDEO'" :disabled="submittingForm" />
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'TaskPopup',
  props: ['popupId', 'brandTutorialVideoDetails', 'editBrandTutorialVideoFlag'],
  data: function () {
    return {
      submittingForm: false,
      imageSelected: false,
      currentImage: ''
    }
  },
  methods: {

    getVideoId () {
      let videoLinkArray = this.brandTutorialVideoDetails.video_url.split('/')
      this.brandTutorialVideoDetails.video_id = videoLinkArray[videoLinkArray.length - 1]
    },
    addBrandTutorialVideo () {
      this.$validator.validateAll('add-brand-tutorial-video').then((result) => {
        if (result) {
          this.submittingForm = true
          let action = 'addBrandTutorialVideo'
          let message = 'added'
          if (this.editBrandTutorialVideoFlag) {
            action = 'updateBrandTutorialVideo'
            message = 'updated'
          }
          this.$store.dispatch(action, this.brandTutorialVideoDetails).then(() => {
            this.$refs.popupCloseButton.click()
            this.resetForm()
            this.$notify({ type: 'success', text: 'Task Data Point has been ' + message + ' successfully' })
            this.submittingForm = false
            this.$emit('updateBrandTutorialVideosList')
          }, (response) => {
            for (var key in response.body) {
              this.$notify({ type: 'error', text: response.body[key][0] })
              let field = this.$validator.fields.find({ name: key, scope: 'add-task' })

              if (field) {
                this.$validator.errors.add({
                  id: field.id,
                  field: key,
                  msg: response.body[key][0],
                  scope: 'add-task'
                })

                field.setFlags({
                  invalid: true,
                  valid: false,
                  validated: true
                })
              }
            }
            this.errorMessage = response.body.message
            this.submittingForm = false
          })
        } else {
          if (this.errors.has('add-task.password:min')) {
            this.$notify({ type: 'error', text: 'Password should be at least 6 letters' })
          } else if (this.errors.has('add-task.contact_mobile:regex')) {
            this.$notify({ type: 'error', text: 'Please enter a valid mobile number' })
          } else {
            this.$notify({ type: 'error', text: 'Please fill out all the required fields' })
          }
        }
      })
    },

    resetForm () {
      Object.assign(this.$data, this.$options.data.apply(this))
      this.errors.clear('add-task')
    }
  }
}
</script>

<style scoped>
.btn-negative {
  font-size: 15px;
  font-weight: 400;
  margin-top: 0;
}

.image-upload {
  display: inline-block;
  width: auto;
  text-align: center;
}
</style>
